import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const HIDE_ON = ['/download'];

const BackToTop = () => {
    const [visible, setVisible] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        if (HIDE_ON.includes(pathname)) {
            setVisible(false);
            return;
        }

        let ticking = false;
        const onScroll = () => {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(() => {
                setVisible(window.pageYOffset > 320);
                ticking = false;
            });
        };

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [pathname]);

    if (HIDE_ON.includes(pathname) || !visible) return null;

    return (
        <button
            type="button"
            aria-label="回到顶部"
            onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}
            className="fixed bottom-6 right-5 md:bottom-8 md:right-8 z-[60] flex h-11 w-11 md:h-12 md:w-12 items-center justify-center rounded-full bg-blue-600 text-white shadow-lg shadow-blue-600/30 hover:bg-blue-700 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-300"
        >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2.2} viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
            </svg>
        </button>
    );
};

export default BackToTop;
